module.exports = __webpack_public_path__ + "components/forecast-table/static/weather-forecast_sunset-3a0d6151ef6b0d0d9d1526ceb2c865c2.svg";